<template>
  <basic-container>
    <!-- 页面头部信息 -->
    <div class="page-header" v-if="sessionInfo">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="info-item">
            <label>会话ID：</label>
            <span>{{ sessionInfo.sessionId }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="info-item">
            <label>会话标题：</label>
            <span>{{ sessionInfo.sessionTitle || '无标题' }}</span>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 消息列表 -->
    <avue-crud 
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      ref="crud"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange">

      <!-- 消息类型显示 -->
      <template slot="msgType" slot-scope="scope">
        <el-tag 
          :type="getMsgTypeColor(scope.row.msgType)"
          size="small">
          {{ getMsgTypeText(scope.row.msgType) }}
        </el-tag>
      </template>
      <template slot="sendUserType" slot-scope="scope">
        <el-tag 
          size="small">
          {{ getSendUserTypeText(scope.row.sendUserType) }}
        </el-tag>
      </template>
              <!-- 响应时长显示 -->
      <template slot="reponseMills" slot-scope="scope">
          <span>{{ scope.row.reponseMills || '0' }}</span>
      </template>
      <!-- UID显示 -->
      <template slot="uid" slot-scope="scope">
        <span>{{ scope.row.uid || '-' }}</span>
      </template>
      <!-- 消息内容显示 -->
      <template slot="content" slot-scope="scope">
        <div class="message-content">
          <el-tooltip 
            :content="scope.row.content"
            placement="top"
            :disabled="!scope.row.content || scope.row.content.length <= 50">
            <span>{{ truncateText(scope.row.content, 50) }}</span>
          </el-tooltip>
        </div>
      </template>

      <template slot="menu" slot-scope="scope">
        <el-button 
          type="text"
          size="small"
          icon="el-icon-s-order"
          @click="handleViewTasks(scope.row)">
          查看任务
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
  
</template>

<script>
import { getAiSessionMsgList } from "@/api/aiSession";

export default {
  name: 'AiSessionMessages',
  
  data() {
    return {
      loading: false,
      data: [],
      sessionInfo: null,
      page: {
        size: 10,
        current: 1,
        total: 0
      },
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: false,
        border: true,
        index: true,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        selection: false,
        dialogClickModal: false,
        labelWidth: 120,
        labelPosition: 'right',
        span: 8,
        excelBtn: true,
        column: [
        {
            label: "消息ID",
            prop: "msgId",
            minWidth: 120,
            overHidden: true,
            tip: true
          },
          {
            label: "chatId",
            prop: "chatId",
            minWidth: 200,
            overHidden: true,
            tip: true
          },
          {
            label: "消息发送方",
            prop: "sendUserType",
            minWidth: 100,
            slot: true
          },
          {
            label: "发送方UID",
            prop: "uid",
            minWidth: 120,
            overHidden: true,
            tip: true
          },
          {
            label: "消息内容",
            prop: "content",
            minWidth: 200,
            slot: true
          },
          {
            label: "响应时长(ms)",
            prop: "reponseMills",
            span: 6,
            search: false,
            width: 120,
            type: "number",
            slot: true
          },
          {
            label: "创建时间",
            prop: "createTime",
            width: 160,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss"
          },
          {
            label: "结束时间",
            prop: "endTime",
            width: 160,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss"
          }
        ]
      }
    };
  },
  
  watch: {
    // 监听路由变化，支持同页内切换不同会话
    '$route.query.sessionId'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.initFromRoute();
      }
    },
    '$route.query.sessionTitle'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.sessionInfo.sessionTitle = newVal;
      }
    }
  },
  
  mounted() {
    // 初始从路由读取参数
    this.initFromRoute();
  },
  
  methods: {
    // 从路由参数初始化并加载
    initFromRoute() {
      const routeSessionId = this.$route.query.sessionId;
      const routeSessionTitle = this.$route.query.sessionTitle;
      this.sessionInfo = {
        sessionId: routeSessionId,
        sessionTitle: routeSessionTitle
      };
      // 缺少会话ID时，不强制回退，保持静默并清空数据，避免关闭页面时报错
      if (!this.sessionInfo.sessionId) {
        this.page.current = 1;
        this.page.total = 0;
        this.data = [];
        this.loading = false;
        return;
      }
      // 路由变更时重置分页到第一页并加载
      this.page.current = 1;
      this.loadMessageList();
    },
    // 获取消息类型颜色
    getMsgTypeColor(type) {
      const typeMap = {
        'user': 'primary',
        'assistant': 'success',
        'system': 'warning',
        'error': 'danger'
      };
      return typeMap[type] || 'info';
    },
    
    // 获取消息类型文本
    getSendUserTypeText(sendUserType) {
      const sendUserTypeMap = {
        '1': '用户消息',
        '2': 'AI回复'
      };
      return sendUserTypeMap[sendUserType] || sendUserType;
    },
     
    // 获取消息类型文本
    getMsgTypeText(type) {
      const typeMap = {
        'user': '用户消息',
        'assistant': 'AI回复',
        'system': '系统消息',
        'error': '错误消息'
      };
      return typeMap[type] || type;
    },
    // 截断文本
    truncateText(text, maxLength) {
      if (!text) return '';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },
    
    // 当前页变化
    currentChange(currentPage) {
      this.page.current = currentPage;
      this.loadMessageList();
    },
    
    // 页大小变化
    sizeChange(pageSize) {
      this.page.size = pageSize;
      this.loadMessageList();
    },
    
    // 刷新
    refreshChange() {
      this.loadMessageList();
    },
    
    // 加载消息列表
    loadMessageList() {
      // 无有效会话ID时不请求，直接清空
      if (!this.sessionInfo || !this.sessionInfo.sessionId) {
        this.data = [];
        this.page.total = 0;
        this.loading = false;
        return;
      }
      this.loading = true;
      const requestData = {
        current: this.page.current,
        size: this.page.size,
        sessionId: this.sessionInfo.sessionId
      };
      
      getAiSessionMsgList(requestData).then(res => {
        console.log('消息列表API响应:', res.data);
        if (res.data.code === 200 || res.data.code === 0) {
          const data = res.data.data;
          console.log('消息列表数据:', data);
          if (data.records && data.records.length > 0) {    
            console.log('第一条消息数据:', data.records[0]);
            console.log('第一条消息的uid字段:', data.records[0].uid);
          }
          this.page.total = data.total;
          this.data = data.records || [];
          this.loading = false;
        } else {
          this.loading = false;
          this.$message.error(res.data.msg || "获取消息列表失败");
        }
      }).catch(error => {
        this.loading = false;
        console.error("获取消息列表失败:", error);
        this.$message.error("获取消息列表失败，请重试");
      });
    },

    // 查看任务
    handleViewTasks(row) {
      this.$router.push({
        path: '/aiSession/tasks',
        query: {
          chatId: row.chatId, 
          sessionId: this.sessionInfo.sessionId,
          sessionTitle: this.sessionInfo.sessionTitle
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-header {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
  
  .info-item {
    margin-bottom: 8px;
    
    label {
      font-weight: 500;
      color: #606266;
      margin-right: 8px;
    }
    
    span {
      color: #303133;
    }
  }
}

.message-content {
  line-height: 1.5;
  word-break: break-word;
}

/* 表格单元格文本溢出处理 */
.el-table .cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* 确保tooltip正常显示 */
.el-tooltip__popper {
  max-width: 400px;
  word-break: break-all;
  line-height: 1.5;
}

/* 状态标签样式 */
.el-tag {
  margin: 0;
}
</style>


